import { gql } from './../../types';

export const GENERATE_SHOPIFY_URL = gql(`
  mutation GenerateShopifyUrl($input: GenerateShopifyRedirectUrlInput!) {
    generateShopifyUrl(input: $input) {
      redirectUrl
    }
  }
`);
